import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Note } from './note-info';

@Component({
  selector: 'app-note-info',
  templateUrl: './note-info.component.html',
  styleUrls: ['./note-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NoteInfoComponent {
  @Input() note: Note;
  @Input() fillSpace = false;
}
